/**
 * このカスタムフックがある理由
 *
 * stateがない状態で、useTraining、useTrainingCompleteを呼ぶとメモ化している影響で
 * useEffectで遷移チェックしても、undefinedでエラーになってしまうため、
 * 画面表示時にエラーにならないために、とりあえずAPIでエラーになる値を返している。
 * （遷移許可で、自動でトレーニング選択画面に戻される）
 */
import { useMemo } from 'react';
import { useLocation } from 'react-router';
import { SelectTrainingPageState } from './useSelectTraining';

const useTrainingState = (): SelectTrainingPageState => {
  // location
  const location = useLocation<SelectTrainingPageState>();

  /**
   * トレーニングID
   * @return stateがなければ-1/あればその値
   */
  const trainingId = useMemo(() => {
    //
    if (location.state === undefined) {
      return -1;
    }
    if (location.state.trainingId === undefined) {
      return -1;
    }

    return location.state.trainingId;
  }, [location]);

  /**
   * コンテンツ一覧
   * @return stateがなければ空配列/あればその値
   */
  const contents = useMemo(() => {
    //
    if (location.state === undefined) {
      return [];
    }
    if (location.state.contents === undefined) {
      return [];
    }

    return location.state.contents;
  }, [location]);

  return {
    trainingId,
    contents,
  };
};

export default useTrainingState;
